exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-0491010d]{cursor:pointer}.form-text[data-v-0491010d]{font-size:.75rem;margin-top:2px}", ""]);

// exports
